<template>
  <div class="chartbox">
    <div id="dom" ref="chartdom"></div>
    <div id="val">
      <div>
        <span>{{ info.val }}</span
        ><span class="unit">{{ info.unit }}</span>
      </div>
      <div class="key">{{ info.key }}</div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import resize from "@/components/Charts/mixins/resize";
import { debounce } from "@/utils";
import _ from "lodash";
export default {
  // mixins: [resize],
  props: ["info"],
  data() {
    return {
      chart: 12,
    };
  },
  mounted() {
    this.initChart(this.info.pie || 0);
    this.resizeHandler = _.debounce(
        this.chart.resize
      , 300),
    window.addEventListener("resize", this.resizeHandler);
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    window.removeEventListener("resize", this.resizeHandler);
    this.chart.dispose();
    this.chart = null;
  },
  watch: {
    info: function (newval, oldval) {
      if (newval !== oldval) {
        this.initChart(newval.pie);
      }
    },
  },
  methods: {
    initChart(val) {
      this.chart = echarts.init(this.$refs.chartdom);
      let space = {
        value: 3,
        name: "",
        itemStyle: {
          normal: {
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            color: "rgba(0, 0, 0, 0)",
            borderColor: "rgba(0, 0, 0, 0)",
            borderWidth: 0,
          },
        },
      };
      let option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "5%",
          left: "center",
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["87%", "90%"],
            silent: true,
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              space,
              {
                value: 94 - val,
                name: "",
                itemStyle: {
                  normal: {
                    // borderWidth: 1,
                    // shadowBlur: 20,
                    borderRadius: 20, // 圆角
                    color: "#21e8b1",
                    borderColor: "none",
                    shadowColor: "none",
                  },
                },
              },
              space,
              {
                value: val,
                name: "",
                itemStyle: {
                  normal: {
                    borderWidth: 3,
                    // shadowBlur: 20,
                    borderRadius: 20, // 圆角
                    color: "#36dffc",
                    borderColor: "#36dffc",
                    shadowColor: "#36dffc",
                  },
                },
              },
            ],
          },
        ],
      };
      this.chart.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
#dom {
  width: 100%;
  height: 100%;
  >>> * {
    width: 100%;
    height: 100%;
  }
}
.chartbox {
  width: 0.3rem;
  height: 0.3rem;
  position: relative;
}
#val {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0) scale(0.8);
  color: #151a86;
  font-weight:500;
  div {
    font-size: 0.03rem;
    text-align: center;
  }
  .unit {
    transform: translate3d(-50%, -50%, 0) scale(0.8);
  }
  .key {
    margin-top: 0.01rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/webgl/ui/charts/pie.vue